export default {"uiCheckbox":"ZiZYo","active":"Mlhnd","icon":"rjFWK"};